import { render, staticRenderFns } from "./AccountManagementModal.vue?vue&type=template&id=c96cb960&"
import script from "./AccountManagementModal.vue?vue&type=script&lang=js&"
export * from "./AccountManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./AccountManagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccountManagementModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/AccountManagementModal.vue
// module id = 2325
// module chunks = 1